<template>
  <div
    class="loader"
    :class="classes"
  >
    <div class="loader-spinner" />
  </div>
</template>

<script>
export default {
  name: 'KfLoader',
  props: {
    loaderSpeed: {
      type: String,
      default: 'normal',
    },
    loaderSize: {
      type: String,
      default: 'md',
    },
    loaderColor: {
      type: String,
      default: 'black',
    },
  },
  computed: {
    classes() {
      return {
        [`has-speed-${this.loaderSpeed}`]: this.loaderSpeed,
        [`has-size-${this.loaderSize}`]: this.loaderSize,
        [`has-color-${this.loaderColor}`]: this.loaderColor,
      };
    },
  },
};
</script>

<style lang="postcss">
.loader {
  @apply absolute top-0 right-0 bottom-0 left-0 w-full h-full flex justify-center items-center;

  &-spinner {
    @apply border-black border-8 rounded-full;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-name: rotate-forever;
    animation-timing-function: linear;
    height: 100px;
    width: 100px;
    border-right-color: transparent;
  }

  &.has-speed {
    &-slow {
      .loader-spinner {
        animation-duration: 1500ms;
      }
    }

    &-fast {
      .loader-spinner {
        animation-duration: 750ms;
      }
    }
  }

  &.has-size {
    &-sm {
      .loader-spinner {
        height: 50px;
        width: 50px;
      }
    }

    &-lg {
      .loader-spinner {
        height: 200px;
        width: 200px;
      }
    }
  }

  &.has-color {
    &-white {
      .loader-spinner {
        @apply border-white;
        border-right-color: transparent;
      }
    }

    &-primary {
      .loader-spinner {
        @apply border-primary-bravo;
        border-right-color: transparent;
      }
    }
  }
}


@keyframes rotate-forever {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>






